// components
import GridPageAbstract from '../abstract/GridPageAbstract';

export default class CountriesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicCountries';
        this.Server = this.props.context.getState().server.publicCountries;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name', 'countryCode'];
        this.showDatePicker = false;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                { id: 'name', label: 'name', alignRight: false, cell: 'Text', displayGrid: true },
                { id: 'countryCode', label: 'countryCode', alignRight: false, cell: 'Text', displayGrid: true },
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
